import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';
import { getDesktopOrMobile } from './Utils/deviceDetails';
import PlumAppointment from './Components/PlumAppointment/plumAppointment';
import PlumIframeLink from './Components/PlumIframeLink/iframeLink';
import TeleDentistry from './Components/TeleDentistry/teleDentistry';
import InsuranceLogin from './Components/Authentication/Login';
import SsoLogin from './Components/Authentication/SsoLogin';
import ThirdpartyAppointment from './Components/thirdparty/ThirdpartyAppointment';
import MyBookings from './Components/MyBookings';
import NetworkLocator from './Components/NetworkLocator';
import PhonepeEntry from './Components/PhonepePortal/PhonepeEntry';
import PhonepeLogin from './Components/PhonepePortal/PhonepeLogin';
import PhonepeDashboard from './Components/PhonepePortal/PhonepeDashboard';
import PhonepeMyBookings from './Components/PhonepePortal/PhonepeMyBookings';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {

    const [isDesktop, setDeviceType] = useState(false)
    const [isLandscape, setLandscape] = useState(window.innerWidth > window.innerHeight)
    const handleOrientation = () => {
        detectDevice()
        setLandscape(window.innerWidth > window.innerHeight)
        document.documentElement.style.setProperty("--browser-offset", `calc(var(--vh, 1vh) * 100 - ${window.innerHeight}px)`);
    }

    const detectDevice = () => {
        const isDesktopWindows = getDesktopOrMobile()
        setDeviceType(isDesktopWindows)
    }

    useEffect(() => {
        window.addEventListener("resize", handleOrientation)
        handleOrientation()
        // window.open()
        return () => {
            window.removeEventListener("resize", handleOrientation)
        }
    }, [])


    return (
        <div className="App" style={{ minHeight: '100vh', background: '#f8fafc' }}>
            <Routes>
                <Route exact path="/" element={<PlumIframeLink />} />
                <Route exact path="/:company-appointment" element={<PlumAppointment/>} />
                <Route exact path="/tele-dentistry/:client" element={<TeleDentistry />} />
                <Route exact path="/insurance/login" element={<InsuranceLogin/>} />
                {/* Sign-in link from a client app: /sso?code=<one-time code> */}
                <Route exact path="/sso" element={<SsoLogin />} />
                <Route exact path="/thirdparty-appointment" element={<ThirdpartyAppointment />} />
                <Route exact path="/my-bookings" element={<MyBookings />} />
                <Route exact path="/phonepe" element={<PhonepeEntry />} />
                <Route exact path="/phonepe/login" element={<PhonepeLogin />} />
                <Route exact path="/phonepe/dashboard" element={<PhonepeDashboard />} />
                <Route exact path="/phonepe/bookings" element={<PhonepeMyBookings />} />
                {/* Public page - no session required. Static segments outrank the
                    dynamic "/:company-appointment" route in React Router v6 ranking. */}
                <Route exact path="/network-locator" element={<NetworkLocator />} />
                <Route path="*" element={<PlumIframeLink />} />
            </Routes>
            <ToastContainer />
        </div>
    );
}

export default App;